

export function formatMoney(amount) {
    if (isNaN(Number(amount))) {
        return amount;
    }
    // 向上取整到分
    const roundedAmount = Math.ceil(Number(amount) * 100) / 100;
    return '￥' +roundedAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}